import React from 'react';
import styles from '../styles/WelcomeToArms.module.css';

export default function WelcomeToArms() {
  return (
    <div className={styles.WelcomeToArms_151_10496}>Welcome to ARMS Dashboard</div>
  );
} 